<app-chips-autocomplete
        [parentFormGroup]="parentFormGroup"
        [parentFormControlName]="parentFormControlName"
        [elements]="lovValueElements"
        [loading]="service.loading$ | async"
        [loadingError]="service.error$ | async">
</app-chips-autocomplete>
